// =========================================================
// * Vue Material Dashboard PRO - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
import VueResource from "vue-resource";
// Notifications plugin. Used on Notifications page
import Notifications from "@/components/NotificationPlugin";
import NProgress from "vue-nprogress";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";

// router setup
import routes from "./routes/routes";

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(VueResource);
Vue.use(Notifications);

const NProgressOptions = {
  latencyThreshold: 0, // Number of ms before progressbar starts showing, default: 100,
  router: true, // Show progressbar when navigating routes, default: true
  http: true // Show progressbar when doing Vue.http, default: true
};
Vue.use(NProgress, NProgressOptions);

const nprogress = new NProgress({ parent: ".nprogress-container" });

// This script is released to the public domain and may be used, modified and
// distributed without restrictions. Attribution not necessary but appreciated.
// Source: https://weeknumber.net/how-to/javascript
// Returns the ISO week of the date.
Date.prototype.getWeek = function() {
  var date = new Date(this.getTime());
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  // January 4 is always in week 1.
  var week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  return (
    1 +
    Math.round(
      ((date.getTime() - week1.getTime()) / 86400000 -
        3 +
        ((week1.getDay() + 6) % 7)) /
        7
    )
  );
};
// Returns the four-digit year corresponding to the ISO week of the date.
Date.prototype.getWeekYear = function() {
  var date = new Date(this.getTime());
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  return date.getFullYear();
};
// Returns number of days to date
Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

// Define global
Vue.mixin({
  methods: {
    sortCollection: function(data, key, dir) {
      if (dir !== "asc") {
        dir = "desc";
      }

      return data.sort((a, b) => {
        let modifier = 1;
        if (dir === "desc") modifier = -1;
        if (a[key] < b[key]) return -1 * modifier;
        if (a[key] > b[key]) return 1 * modifier;
        return 0;
      });
    },
    sortAll: function(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;

        if (a[sortBy] === undefined || b[sortBy] === undefined) {
          return 0;
        }

        if (!isNaN(a[sortBy]) && !isNaN(b[sortBy])) {
          if (
            this.currentSortOrder === "asc" &&
            parseInt(a[sortBy]) < parseInt(b[sortBy])
          ) {
            return -1;
          }
          if (
            this.currentSortOrder === "asc" &&
            parseInt(a[sortBy]) > parseInt(b[sortBy])
          ) {
            return 1;
          }
          if (
            this.currentSortOrder === "desc" &&
            parseInt(a[sortBy]) < parseInt(b[sortBy])
          ) {
            return 1;
          }
          if (
            this.currentSortOrder === "desc" &&
            parseInt(a[sortBy]) > parseInt(b[sortBy])
          ) {
            return -1;
          }

          return 0;
        }

        if (this.currentSortOrder === "asc") {
          return a[sortBy].toString().localeCompare(b[sortBy].toString());
        }

        return b[sortBy].toString().localeCompare(a[sortBy].toString());
      });
    },
    arraySwapItems: function(data, a, b) {
      data[a] = data.splice(b, 1, data[a])[0];
      return data;
    },
    arrayContainsAllItems: function(data, values) {
      for (let i in values) {
        if (data.indexOf(values[i]) === -1) {
          return false;
        }
      }

      return true;
    },
    arrayGetItemsItContains: function(data, values) {
      let returnData = [];
      for (let i in values) {
        if (data.indexOf(values[i]) > -1) {
          returnData.push(values[i]);
        }
      }

      return returnData;
    },
    arrayRemoveValues: function(data, values) {
      let returnData = [];
      for (let d in data) {
        if (values.indexOf(data[d]) === -1) {
          returnData.push(data[d]);
        }
      }

      return returnData;
    },
    UpdateKey: function(obj, oldKey, newKey) {
      let modifiedObj = {};

      for (let [k, v] of Object.entries(obj))
        if (k === oldKey) modifiedObj[newKey] = v;
        else modifiedObj[k] = v;

      return modifiedObj;
    },
    getModuleSettingFromSession(moduleSettingName) {
      if (localStorage.getItem("modules") === null) {
        return false;
      }

      let settings = JSON.parse(localStorage.getItem("modules"));

      if (settings[moduleSettingName] !== undefined) {
        return settings[moduleSettingName];
      }

      return false;
    },
    formatDate(date) {
      if (typeof date !== "string") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    formatDateBack(date) {
      if (typeof date !== "string" || date === "") {
        return null;
      }
      date = date.split("-");
      if (date[2].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    }
  }
});

// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active"
});

// Store API url for the app in this.$apiBaseUrl
Object.defineProperty(Vue.prototype, "$apiBaseUrl", {
  get() {
    var url = window.location.href;
    var arr = url.split("/");
    return arr[0] + "//api." + arr[2] + "/api/";
  }
});

// router.afterEach((to, from) => {
//   console.log(to);
// });

router.beforeEach((to, from, next) => {
  let timestamp = Math.floor(Date.now() / 1000);

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Refresh token flow.
    if (
      localStorage.getItem("access_token") &&
      localStorage.getItem("refresh_token") &&
      parseInt(localStorage.getItem("expires_on")) <= timestamp
    ) {
      let myEle = document.createElement("h3");
      myEle.innerHTML = "Sessie vernieuwen...";
      myEle.style.color = "darkgrey";
      document.body.appendChild(myEle);

      Vue.http
        .post(
          Vue.prototype.$apiBaseUrl + "refresh",
          { refresh_token: localStorage.getItem("refresh_token") },
          { emulateJSON: true }
        )
        .then(
          response => {
            localStorage.setItem(
              "expires_on",
              timestamp + response.data.expires_in
            );
            localStorage.setItem("access_token", response.data.access_token);
            localStorage.setItem("refresh_token", response.data.refresh_token);

            document.body.removeChild(myEle);

            next();
            return;
          },
          response => {
            localStorage.removeItem("access_token");
            localStorage.removeItem("expires_on");
            localStorage.removeItem("refresh_token");

            document.body.removeChild(myEle);

            router.push("/login");
            return;
          }
        );
    } else if (
      localStorage.getItem("access_token") === null ||
      parseInt(localStorage.getItem("expires_on")) < timestamp
    ) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("expires_on");
      localStorage.removeItem("refresh_token");

      router.push("/login");
      return;
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem("access_token") !== null) {
      router.push("/dashboard");
      return;
    }
    next();
  } else {
    next();
  }
});

Vue.http.interceptors.push((request, next) => {
  if (
    request.url.includes(Vue.prototype.$apiBaseUrl) &&
    localStorage.getItem("access_token") !== null
  ) {
    request.headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("access_token")
    );
  }
  next();
});

export default router;

// global library setup
Vue.prototype.$Chartist = Chartist;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  nprogress
});
